/* eslint-disable arrow-body-style */
/* eslint-disable no-param-reassign */
import { combineReducers } from 'redux';

import Logout from './Logout/reducer';
import User from './User/reducer';
import Grupos from './Grupos/reducer';
import Menu from './Menu/reducer';
import SubMenu from './SubMenu/reducer';
import Paginas from './Paginas/reducer';
import Modulos from './Modulos/reducer';

const reducers = combineReducers({
  Logout,
  User,
  Grupos,
  Menu,
  SubMenu,
  Paginas,
  Modulos,
});

export default reducers;
